import { atom } from '@exodus/headless-ui';
import fromAssetsAtom from './from-assets.js';
import toAssetAtom from './to-asset.js';
const isFlippableAtom = atom((get) => {
    const fromAssets = get(fromAssetsAtom);
    const toAsset = get(toAssetAtom);
    return fromAssets.some(({ name }) => toAsset.name === name);
});
export default isFlippableAtom;
